jQuery(document).ready(function($) {
    const templates = {
        searchResult: window.Handlebars.compile(
            document.getElementById('tmpl-search-result').textContent,
        ),
    };

    const searchInput = document.querySelector('[data-flyout="search"] input');
    const searchResults = document.querySelector(
        '[data-flyout="search"] .flyout__body',
    );
    const popular = document.querySelector(
        '[data-flyout="search"] .flyout__body',
    ).innerHTML;

    let timeout = null;
    let controller = null;

    searchInput.addEventListener('input', onSearchInputChange);

    function onSearchInputChange(e) {
        e.preventDefault();

        if (!e.target.value) {
            searchResults.innerHTML = popular;
        } else {
            search(e.target.value);
        }
    }

    function search(query) {
        if (timeout) {
            clearTimeout(timeout);
        }

        if (controller) {
            controller.abort();
        }

        timeout = setTimeout(async () => {
            searchResults.classList.add('loading');

            controller = new AbortController();

            let response;
            try {
                response = await fetch(
                    `/wp-json/svenskamoten/v1/search?query=${query}`,
                    {signal: controller.signal},
                );

                if (response.status !== 200) {
                    throw new Error(response.code);
                }
            } catch (ex) {
                searchResults.classList.remove('loading');

                return;
            }

            const data = await response.json();

            (window.dataLayer || []).push({
                event: 'svm.search',
                query: query,
                results: {
                    hotels: data.hotels.slice(0, 5).map(function(result) {
                        return {
                            name: result.name,
                            permalink: result.permalink,
                        };
                    }),
                    news: data.news.slice(0, 5).map(function(result) {
                        return {
                            name: result.name,
                            permalink: result.permalink,
                        };
                    }),
                    pages: data.pages.slice(0, 5).map(function(result) {
                        return {
                            name: result.name,
                            permalink: result.permalink,
                        };
                    }),
                    campaigns: data.campaigns.slice(0, 5).map(function(result) {
                        return {
                            name: result.name,
                            permalink: result.permalink,
                        };
                    }),
                },
            });

            let isEmpty = true;

            $.each(data, function(key, value) {
                if (!Array.isArray(value) || value.length > 0) {
                    isEmpty = false;
                    return false;
                }
            });

            if (isEmpty) {
                searchResults.innerHTML = popular;
            } else {
                searchResults.innerHTML = templates.searchResult(data);
            }

            searchResults.classList.remove('loading');
        }, 500);
    }

    function render(items) {

    }
});

//# sourceMappingURL=search.js.map
